export default __webpack_public_path__ + "static/MineralSwimV2_BENEFITS_OzonePurification_1920x1000-e9948eebe9b455186d401743d6833857.jpg";